export default __webpack_public_path__ + "static/site-header-3000x516-1-6d8191401f9a3aac62777f2277027fc5.jpg";